import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import microsoftImage from '../../../assets/images/microsoft image.webp';

const certificates = [
  {
    title: 'Microsoft Azure AI Essentials',
    issuedBy: 'Microsoft',
    date: '6 December 2025',
    image: microsoftImage,
    link: 'https://drive.google.com/file/d/1mMzfqrFkRBudkPHIiX8ulIYFgjiqyOLS/view?usp=sharing'
  }
];

const MicrosoftCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="Microsoft"
      certificates={certificates}
    />
  );
};

export default MicrosoftCertificates;
